import { get, post, del } from '../../../../services/request';

// Fetch Custom Views
export const fetchCustomViewsAPI = (payload) => {
    return get(`Radiologist/GetAllRadiologistCustomViewsByUserID?UserID=${payload.UserID}`);
};

// Toggle Custom View Status
export const toggleCustomViewStatusAPI = (payload) => {
    return post('Radiologist/ActivateDeactivate', payload);
};

// Delete Custom View
export const deleteCustomViewAPI = (payload) => {
    return post('Radiologist/DeleteRadiologistCustomView', payload);
};

// Fetch Rad Custom View
export const fetchRadCustomViewAPI = (payload) => {
    return post(`Radiologist/GetAllRadiologistsNew?id=${payload.id}`);
};

// Fetch Custom View Share Dropdown in AddRadCustomViewModal
export const fetchCustomViewShareDropdownAPI = (payload) => {
    return post('Radiologist/GetCustomViewSharedList', payload);
};

// Save Shared Custom View
export const saveSharedCustomViewAPI = (payload) => {
    return post('Radiologist/SharedCustomView', payload);
};
// services/radiologistServices.js
export const fetchRadiologistAllDDListAPI = () => {
    return get('Radiologist/GetRadiologistAllDDList');
};

export const saveRadiologistCustomViewAPI = payload =>
    post('/Radiologist/SaveRadiologistCustomView', payload);
